import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'
import { wording } from "src/constants/constants.js";

export const FETCH_DELIVERY_CHECK_IN_LOG = 'FETCH_DELIVERY_CHECK_IN_LOG'
export const RECEIVE_DELIVERY_CHECK_IN_LOG = 'RECEIVE_DELIVERY_CHECK_IN_LOG'
export const FAILED_DELIVERY_CHECK_IN_LOG = 'FAILED_DELIVERY_CHECK_IN_LOG'

export function fetchDeliveryCheckInLog(_id){

    return (dispatch, getState) => {
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_DELIVERY_CHECK_IN_LOG});
        axios({
            method: 'post',
            url: API_LINKS.DELIVERY_CHECK_IN_LOG_URL,
            headers: {
                Authorization: auth
            },
            data: {
                id_delivery_order: _id,
                // date: 
                // For Parameters
            }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_DELIVERY_CHECK_IN_LOG,
                payload: response.data.result.checkin
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if(error.response){
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_DELIVERY_CHECK_IN_LOG
                    })
                    return toast.error("Unathorized access!");
                    
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_DELIVERY_CHECK_IN_LOG
                    })
                    return toast.error("Failed in fetching "+wording["Delivery Order"]+"s List. Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_DELIVERY_CHECK_IN_LOG
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_DELIVERY_CHECK_IN_LOG
                    })
                    return toast.error("Please contact your system adminitrator")
                }
            }else if (error.request) {
                dispatch({
                    type: FAILED_DELIVERY_CHECK_IN_LOG
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_DELIVERY_CHECK_IN_LOG
                })
                return toast.error('Something went wrong... Please try again later...')
            }

        })
    }
}